import { DateTime } from 'luxon';
export var dateComparator = function dateComparator(key, descending) {
  return function (a, b) {
    var aValue = key === undefined ? a : a[key];
    var bValue = key === undefined ? b : b[key];
    var aDateTime = DateTime.fromISO(aValue);
    var bDateTime = DateTime.fromISO(bValue);
    if (aDateTime === bDateTime) return 0;
    return (descending ? 1 : -1) * (aDateTime > bDateTime ? -1 : 1);
  };
};